export default "__VITE_ASSET__myOjbRUD__"